import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { enmOrderingType } from "../../components/infrastructure/models";
import { IBank, IBankProps, IBankStates } from "./interfaces";

export class Bank extends EntityManager<IBank, IBankProps, IBankStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "Bank",
            title: "بانک",
            Properties: [
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام بانک را وارد نمایید' }]
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 100,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }],
                    showInLookup: false
                }
            ]
        };
    };

    onInitializing() {
        this.searchable = true;
        this.searchArea = { columnsPerRow: 2 };
        this.originalOrderings = () =>  [{ Property: "Code", OrderBy: enmOrderingType.Ascending }];
    }
}